export default "<img [src]=\"getImgUrl(image)\" style=\"object-fit: contain; width: 100%; height: 100%;\" *ngIf=\"image\">\n"